type Props = {
  value: string
  onChange: (value: string) => void
}

export default function PodcastSearchBar({ value, onChange }: Props) {
  return (
    <input
      type="search"
      className="podcast-search-bar"
      placeholder="Search podcasts…"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search podcasts"
    />
  )
}
